/*
 *
 */
import * as React from 'react';
import Page from '../components/page';
import Button from '../components/button';
import { StaticImage } from 'gatsby-plugin-image';
import { FloatingImage } from '../components/image';

/*
 *
 */
const PageContent = () => {
	return (
		<Page
			title="Soutien à la parentalité"
			intro="La parentalité est un processus dynamique du « devenir parent ». C’est un phénomène évolutif, nécessitant des réaménagements à chaque étape du développement de l’enfant, ainsi qu’en fonction des évènements de vie familiaux."
			content={(
				<React.Fragment>
					<FloatingImage>
						<StaticImage
							backgroundColor="rgba(255,255,255,.25)"
							src="../images/Parentalite-Isabelle-Kopp.jpeg"
							alt="Soutien à la parentalité - Isabelle Kopp"
							width={1920}
							sizes="(max-width: 768px) 50vw, 960px"
						/>
					</FloatingImage>

					<p>
						Ce processus ne va pas forcément toujours de soi, on apprend tous les jours à être parents.
					</p>

					<p>
						Il y a des moments où l’on peut ressentir de grand bonheur et être confiant dans ses compétences et d’autres où l’on peut se sentir perdu, démuni et/ou épuisé, dépassé.
					</p>

					<p>
						Le soutien à la parentalité s'adresse aussi bien <strong>aux couples désirant avoir un enfant, qu'aux parents et futurs parents</strong>. Toutes les thématiques peuvent y être évoquées :
					</p>

					<ul>
						<li>Les difficultés de conception</li>
						<li>Les difficultés éducatives</li>
						<li>Le vécu de la grossesse pour la mère comme pour le père</li>
						<li>La préparation à l’accouchement</li>
						<li>L’allaitement</li>
						<li>Les choix de maternage</li>
						<li>Le vécu scolaire</li>
						<li>Les choix pédagogiques</li>
						<li>La prévention des troubles du parent ou de l’enfant</li>
						<li>Le maintien de l’harmonie familiale</li>
					</ul>

					<p>
						Les objectifs de cette aide psychologique sont :
					</p>

					<ul>
						<li>D’aider les parents à reprendre confiance en eux et dans leur rôle de parents et à utiliser leur compétence</li>
						<li>De favoriser la relation avec votre enfant et la compréhension de sa vie psychique</li>
						<li>De renforcer l’interaction positive entre l’enfant et sa famille.</li>
					</ul>

					<p>
						La consultation est un lieu d’écoute et d’échange pour comprendre ensemble ce qui se passe avec votre enfant.
					</p>

					<br />
					<Button to="/rendez-vous/" label="Prendre un rendez-vous" />
				</React.Fragment>
			)}
		>
			<title>Soutien à la parentalité — Isabelle Kopp</title>
		</Page>
	);
};

export default PageContent;
